export default __webpack_public_path__ + "static/media/VR.5969a191.png";